module.exports = __webpack_public_path__ + "img/false-positives.c27898b.png";